import { FormikHelpers } from "formik";
import { useCreateEstablishment } from "./api/createEstablishment";
import CreateEstablishmentForm from "./CreateEstablishmentForm";


const CreateEstablishment = ({handleCloseModal}: CreateEstablishmentProps)  => {
  const createEstablishmentMutation = useCreateEstablishment({data: {}});

  const initialValues: ICreateEstablishmentForm = {
    description: "",
    modemID: "",
    unID: "",
    placeID: "",
    modemPort: "",
    sapCode: "",
    isEmporiki: false,
    isCiti: false,
    deleted: false,
    filepath: "",
    hubType: "",
    anetVoice: "",
    comments: "",
  };

  const handleSubmit = async (values: ICreateEstablishmentForm, { setSubmitting }: FormikHelpers<ICreateEstablishmentForm>): Promise<void> => {
    try {
      await createEstablishmentMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <CreateEstablishmentForm initialValues={initialValues}  onSubmit={handleSubmit} />
  )
}

interface CreateEstablishmentProps {
  handleCloseModal: () => void;
}

export default CreateEstablishment;